export enum LanguageEnum {
  PT_BR = 1,
  EN_US = 2
}
